



















import Logo from '@/components/Logo.vue';

export default {
  components: {
    Logo,
  },
};
